import type { GlobalState } from '@/components/context/Silverstripe';

let globalData: GlobalState = {} as GlobalState;

try {
  // Use require so missing file in CI/preview does not fail type-check/module resolution. scripts/fetch-global-data.js is expected to create this file before runtime usage.
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  globalData = require('../global-data.json') as GlobalState;
} catch (error) {
  // Fallback to empty object; downstream defaults in context/app state will be used.
  globalData = {} as GlobalState;
}

const globalState = globalData;

export default globalState;
